module.exports = __webpack_public_path__ + "static/media/mainBack3.429b2c8e.jpg";